// =============================================================================
//  Copyright : 2018 semantics GmbH
//  Date      : $Date: 2021-05-07 11:50:23 +0200 (Fri, 07 May 2021) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 119160 $
//  Purpose   : I18N related parts
// =============================================================================
// ---Third-party imports
import React, {Component, Fragment} from 'react'

// ---Framework imports
import log from 'uix/logging'
import {keys} from 'ldash'
import {useSelector} from 'uix/hooks'

// ---Local imports
import {I18NTable} from './components'

// ---Globals
export const TestI18N = ({dname}) => {
  return <I18NTable dname={dname} flex />
}
